import React from 'react';

export const ErrorsContext = React.createContext(null);
